import React, { useEffect, useRef, useState } from "react";

const PLATFORM_COLORS = {
  CodeChef: "#5b4638",
  Codeforces: "#1a8bcc",
  LeetCode: "#f89f1b",
  HackerRank: "#00ea64",
  GeeksForGeeks: "#2f8d46",
};

const CodingCard = ({ item, index }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVisible(true);
          obs.unobserve(e.target);
        }
      },
      { threshold: 0.15 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);

  const accentColor = PLATFORM_COLORS[item.title] || "var(--im-gold)";

  return (
    <a
      ref={ref}
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`coding-card ${visible ? "coding-card-visible" : ""}`}
      style={{ animationDelay: `${index * 120}ms` }}
    >
      <div className="coding-card-icon">
        <img src={item.image} alt={item.title} />
      </div>
      <div className="coding-card-info">
        <h4>{item.title}</h4>
        <p style={{ color: accentColor }}>{item.category}</p>
      </div>
      <i className="fa fa-external-link coding-card-arrow" />
    </a>
  );
};

const Portfolio = ({ data }) => {
  if (!data) return null;

  return (
    <section id="coding" className="coding-profile-section">
      <h1 className="section-heading">
        <span>Coding Profile</span>
      </h1>
      <div className="coding-cards-grid">
        {data.testimonials.map((item, i) => (
          <CodingCard key={item.title} item={item} index={i} />
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
